import React from 'react';
import Icon from '@xo-union/tk-component-icons';
import styles from './styles.scss';
import { classnames } from '../../helpers/classnames';

interface PillButtonProps {
  children?: string;
  selected: boolean;
  onClick: () => void;
}

export const PillButton = ({ children, selected, onClick, ...rest }: PillButtonProps): JSX.Element => {
  const classes = classnames(styles.pill, styles.pillButton, {
    [styles['pillButton--selected']]: Boolean(selected),
  });
  return (
    <button className={classes} onClick={onClick} aria-pressed={Boolean(selected)} {...rest}>
      {children}
    </button>
  );
};

export const DismissablePillButton = ({
  children,
  onClick,
  ...rest
}: Omit<PillButtonProps, 'selected'>): JSX.Element => {
  const classes = classnames(styles.pill, styles.dismissablePillButton);
  return (
    <button className={classes} onClick={onClick} aria-label={`Clear ${children}`} {...rest}>
      {children}
      <Icon name="close" size="sm" aria-hidden />
    </button>
  );
};
